module.exports = __webpack_public_path__ + "static/media/acai_berry_mic_water.6e92acff.png";